module.exports = __webpack_public_path__ + "img/DJF.687b021b.svg";